import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e3eaa6c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3eaa6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e3eaa6c')) {
      api.createRecord('2e3eaa6c', component.options)
    } else {
      api.reload('2e3eaa6c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e3eaa6c&scoped=true", function () {
      api.rerender('2e3eaa6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/logistics/index.vue"
export default component.exports